<template>
    <div
        style="max-width: 500px"
        class="m-auto community-policing-editor">
        <h1 class="text-center mb-4">Community Policing Editor</h1>
        <b-tabs v-model="tabs"> </b-tabs>
    </div>
    <system-alerts></system-alerts>
</template>
<script setup lang="ts">
import {BTab, BTabs} from "./BTabs";
import DeleteReport from "@/components/CommunityPolicingEditor/DeleteReport.vue";
import ZeroReport from "@/components/CommunityPolicingEditor/ZeroReport.vue";
import {SystemAlerts} from "./Misc";
import { SelectEntryType } from "@/types";
import { ref } from "vue";
const props = defineProps<{
    title: string;
    url: string;
    allowZeroReport: boolean;
    allowDeleteReport: boolean;
}>();

const tabs = ref<BTab[]>([] as BTab[]);

if (props.allowZeroReport) {
    tabs.value.push({id: SelectEntryType.Zero, name: "Zero Report", selected: true, component: ZeroReport});
}

if (props.allowDeleteReport) {
    tabs.value.push({id: SelectEntryType.Delete, name: "Delete Report", selected: false, component: DeleteReport});
}
</script>
<style lang="scss">
.community-policing-editor {
    .form-label {
        font-weight: 600;
    }
}
</style>
